import api from '@/services/api';
import Resource from '@/services/resources/common';

export default class ReportPatternResource extends Resource {
  constructor(entrypoint = '/report_patterns', alias = 'ReportPattern') {
    super(entrypoint, alias);
  }

  fetchPreview(id) {
    return api.get(this.buildUri(id, 'preview_data')).then(({ data }) => data);
  }

  fetchCalculationTypeParams(name) {
    return api.get(this.buildUri('calculation_types'), { name }).then(({ data }) => data);
  }
}
